module.exports = __webpack_public_path__ + "img/11.8e765b14.png";